$(document).ready(function() {
    let quantitySubtract = document.querySelectorAll('[quantity-adjust] [subtract]');
    if (quantitySubtract.length > 0) {
        let quantityAdd = document.querySelectorAll('[quantity-adjust] [add]');
        let getButton = document.querySelectorAll('[get-button]');
        let updateQuantity = function(e) {
            e.preventDefault();
            let direction = this.getAttribute('data-direction');
            let container = this.parentNode;
            let value = parseInt(container.querySelector('input').value);
            let valueDisplay = container.querySelector('qty-display');
            if (direction === 'down') {
                if (value < 1) {
                    value = 0;
                    valueDisplay.innerHTML = 0;
                } else {
                    value--;
                }
            } else if (direction === 'up') {
                value++;
            }
            container.querySelector('input').value = value;
            container.querySelector('.qty-display').innerHTML = value;
        }
        for (let i = 0; i < quantitySubtract.length; i++) {
            quantitySubtract[i].addEventListener('click', updateQuantity);
        }
        for (let i = 0; i < quantityAdd.length; i++) {
            quantityAdd[i].addEventListener('click', updateQuantity);
        }
        for (let i = 0; i < getButton.length; i++) {
            getButton[i].addEventListener('click', function() {
                let form = document.querySelector('[cart-table]');
                let input = form.querySelector('[button-pressed]');
                input.name = this.name;
                input.value = this.value;
            });
        }
    }
});

document.addEventListener('DOMContentLoaded', _=> {
    const webBooksLogo = 'https://res.cloudinary.com/web-books/image/upload/c_limit,f_auto,h_1600,q_auto,w_1600/v1/wb_data/team_4/20210526_103838_0a1cd1fe_webbookslogo_padding_410f36ecf5f594be0e96d4742cdfa1c2?_a=AAFGmGX';

    if (document.querySelector('input[type="file"]') != null) {
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach(input => {
            const fileList = document.querySelector('#' + input.getAttribute('id') + '_fileList')
            checkFiles(input, fileList)
            input.addEventListener('change', _=> {
                checkFiles(input, fileList)
            })
        });
    }

    function checkFiles(input, fileList) {
        if (input.files.length == 0) {
            fileList.innerHTML = '<p>No file chosen</p>'
        } else {
            fileList.innerHTML = '';
            for (let i = 0; i < input.files.length; i++) {
                //fileList.innerText = fileList.innerText + input.files[i].name;
                let newTextElement = document.createElement('p');
                fileList.appendChild(newTextElement)
                newTextElement.appendChild(document.createTextNode(input.files[i].name))
            }
        }
    }

    function checkCustomFontSelected(input, customFileInputsWrapper) {
        const inputs = customFileInputsWrapper.querySelectorAll('.image-selector');
        if (input.value != 0) {
            inputs.forEach(input => {
                input.style.pointerEvents = 'none';
                input.style.opacity = '0.5';
            });
        } else {
            inputs.forEach(input => {
                input.style.pointerEvents = 'all';
                input.style.opacity = '1';
            });
        }
    }

    const fontSelectors = document.querySelectorAll('.font-selection');
    fontSelectors.forEach(selector => {
        const fontMenu = selector.querySelector('.font-menu');
        const customFilesWrapper = selector.querySelectorAll('.custom-files-wrapper');

        customFilesWrapper.forEach(fileWrapper => {
            checkCustomFontSelected(fontMenu, fileWrapper);
            
            fontMenu.addEventListener('change', (ev) => {
                checkCustomFontSelected(fontMenu, fileWrapper);
            })
        });
    });

    function parseRgb(ev) {
        const color = ev.target.value
        const r = parseInt(color.substr(1,2), 16)
        const g = parseInt(color.substr(3,2), 16)
        const b = parseInt(color.substr(5,2), 16)
        return {
            red: r,
            green: g,
            blue: b,
        }
    }

    function rgbToHex(r, g, b) {
        return "#" + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
    }

    const root = document.documentElement;
    const brandingInputs = [
        [ document.querySelector('#primary_colour'), 'primary-color' ],
        [ document.querySelector('#secondary_colour'), 'secondary-color' ],
        // [ document.querySelector('#navbar_text_colour'), 'navbar-text-color' ],
        // [ document.querySelector('#navbar_background_colour'), 'navbar-bg-color'],
        // [ document.querySelector('#navbar_hover_text_colour'), 'navbar-hover-text-color'],
        // [ document.querySelector('#navbar_hover_background_colour'), 'navbar-hover-background-color'],
        // [ document.querySelector('#body_text_colour'), 'body-text-color' ],
        // [ document.querySelector('#sticker_background_colour'), 'sticker-background-color' ]
    ];

    brandingInputs.forEach(arr => {
        const elem = arr[0];
        const cssVar = arr[1];

        const cssVarValues = getComputedStyle(root).getPropertyValue(`--${cssVar}`).replace(/ /g, '').split(',');
        const hex = rgbToHex(cssVarValues[0], cssVarValues[1], cssVarValues[2]);
        
        if (!elem.value) {
            elem.value = hex;
        }

        // elem.value = `rgb(var(--${cssVar}))`;

        elem.addEventListener('input', (ev) => {
            const color = parseRgb(ev);
            root.style.setProperty(`--${cssVar}`, `${color.red}, ${color.green}, ${color.blue}`);
        })
    });

    const brandingImageInputs = [
        [ document.querySelector('.branding-image--logo'), [ 'nav-logo-image', 'white-bg-logo-image' ], document.querySelector('.branding-image--logo-remove') ],
        // [ document.querySelector('.branding-image--white-bg-logo'), 'white-bg-logo-image', document.querySelector('.branding-image--white-bg-logo-remove') ],
    ];

    brandingImageInputs.forEach(arr => {
        const elem = arr[0];
        const previewImgId = arr[1];
        const removeBtn = arr[2];
        let previewImg; 

        if (typeof previewImgId == 'object') {
            previewImg = [];
            previewImgId.forEach(id => {
                previewImg.push(document.querySelector(`#${id}`));
            });
        } else {
            previewImg = document.querySelector(`#${previewImgId}`);
        }

        elem.addEventListener('change', (ev) => {
            const [file] = ev.target.files;
            if (file) {
                if (typeof previewImg == 'object') {
                    previewImg.forEach(element => {
                        element.src = URL.createObjectURL(file);
                    });
                } else {
                    previewImg.src = URL.createObjectURL(file);
                }
            }
        });


        removeBtn.addEventListener('click', (ev) => {
            ev.preventDefault();
            elem.value = null;
            if (typeof previewImg == 'object') {
                previewImg.forEach(element => {
                    element.src = webBooksLogo;
                });
            } else {
                previewImg.src = webBooksLogo;
            }
        })
    });

    function previewFonts(input, className) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                const previewClassElem = document.querySelector(`#${className}`);
                if (previewClassElem) {
                    if (document.querySelector(`.${className}`)) {
                        previewClassElem.remove();
                    }
                }
                const css = '@font-face{'+
                        `font-family: "${className}";`+
                        'src: url("'+e.target.result+'");'+
                    '}';
                const fontClassCss = `.${className} {font-family: "${className}" !important;}`
                head = document.head || document.getElementsByTagName('head')[0],
                
                fontFaceStyle = document.createElement('style');
                head.appendChild(fontFaceStyle);
                fontFaceStyle.type = 'text/css';
                if (fontFaceStyle.styleSheet){
                    fontFaceStyle.styleSheet.cssText = css;
                } else {
                    fontFaceStyle.appendChild(document.createTextNode(css));
                }

                fontClass = document.createElement('style');
                fontClass.id = className;
                head.appendChild(fontClass);
                fontClass.type = 'text/css';
                if (fontClass.styleSheet){
                    fontClass.styleSheet.cssText = fontClassCss;
                } else {
                    fontClass.appendChild(document.createTextNode(fontClassCss));
                }
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    function setPreviewFontFamily(evOrElem, fontPreview, customFontPrimary, customFontSecondary, fontType) {
        const secondaryFontPreview = document.querySelector(`#${fontPreview.id}-secondary`);

        const fontNameInput = document.querySelector(`#${fontPreview.id}-font-name`);
        const fontNameInputSecondary = document.querySelector(`#${secondaryFontPreview.id}-font-name`);

        switch (evOrElem.target ? evOrElem.target.value : evOrElem.value) {
            case "1":
                fontPreview.style.fontFamily = 'Roboto';
                fontPreview.className = "";
                secondaryFontPreview.className = "";
                secondaryFontPreview.style.fontFamily = 'Roboto';
                secondaryFontPreview.classList.add('d-none');

                fontNameInput.value = 'Roboto';
                fontNameInputSecondary.value = 'Roboto';

                break;
            case "13":
                fontPreview.style.fontFamily = 'MrsSaintDelafield';
                secondaryFontPreview.style.fontFamily = 'MrsSaintDelafield';
                fontPreview.className = "";
                secondaryFontPreview.className = "";
                secondaryFontPreview.classList.add('d-none');

                fontNameInput.value = 'MrsSaintDelafield';
                fontNameInputSecondary.value = 'MrsSaintDelafield';
                break;
            case "0":
                // Display the secondary font preview
                secondaryFontPreview.classList.remove('d-none');
        }
    }

    const fontInputs = [
        [ document.querySelector('#default_heading_font'), 'heading-font-preview', 'heading', ],
        [ document.querySelector('#default_body_font'), 'body-font-preview', 'body' ],
        [ document.querySelector('#default_script_font'), 'script-font-preview', 'script' ],
    ];

    fontInputs.forEach(arr => {
        const elem = arr[0];
        const fontPreviewId = arr[1];
        const fontType = arr[2];
        const secondaryFontPreviewId = `${fontPreviewId}-secondary`;

        const customPrimaryId = `branding-font--${fontType}-primary`;
        const customSecondaryId = `branding-font--${fontType}-secondary`;

        const fontPreview = document.querySelector(`#${fontPreviewId}`);
        const secondaryFontPreview = document.querySelector(`#${fontPreviewId}-secondary`);

        const customPrimaryInput = document.querySelector(`.${customPrimaryId}`);
        const customSecondaryInput = document.querySelector(`.${customSecondaryId}`);

        const customPrimaryRemove = document.querySelector(`.${customPrimaryId}-remove`);
        const customSecondaryRemove = document.querySelector(`.${customSecondaryId}-remove`);

        elem.addEventListener('change', (ev) => {
            setPreviewFontFamily(ev, fontPreview, customPrimaryInput, customSecondaryInput, fontType);
        });

        const fontNameInput = document.querySelector(`#${fontPreviewId}-font-name`);
        const fontNameInputSecondary = document.querySelector(`#${secondaryFontPreviewId}-font-name`);
        fontNameInput.value = 'Roboto';
        fontNameInputSecondary.value = 'Roboto';

        customPrimaryInput.addEventListener('change', (ev) => {
            previewFonts(ev.target, `preview-font-primary-${fontType}`);
            fontPreview.classList.add(`preview-font-primary-${fontType}`);

            const fontNameInput = document.querySelector(`#${fontPreviewId}-font-name`);
            fontNameInput.value = "custom";
        });

        customPrimaryRemove.addEventListener('click', (ev) => {
            ev.preventDefault();
            fontPreview.classList.remove(`preview-font-primary-${fontType}`);
            fontPreview.style.fontFamily = 'Roboto';
            customPrimaryInput.value = null;

            const fontNameInput = document.querySelector(`#${fontPreviewId}-font-name`);
            fontNameInput.value = "Roboto";
        })

        customSecondaryInput.addEventListener('change', (ev) => {
            previewFonts(ev.target, `preview-font-secondary-${fontType}`);
            secondaryFontPreview.classList.add(`preview-font-secondary-${fontType}`);

            const secondaryFontNameInput = document.querySelector(`#${secondaryFontPreviewId}-font-name`);
            secondaryFontNameInput.value = "custom";
        });

        customSecondaryRemove.addEventListener('click', (ev) => {
            ev.preventDefault();
            secondaryFontPreview.classList.remove(`preview-font-secondary-${fontType}`);
            secondaryFontPreview.style.fontFamily = 'Roboto';
            customSecondaryInput.value = null;

            const secondaryFontNameInput = document.querySelector(`#${secondaryFontPreviewId}-font-name`);
            secondaryFontNameInput.value = "Roboto";
        })

        setPreviewFontFamily(elem, fontPreview, customPrimaryInput, customSecondaryInput, fontType);
    });

    const enableFooter = document.querySelector('#show_footer');

    const footerInputGroups = [
        document.querySelector('.footer-img-input-group'),
        document.querySelector('.footer-phone-no-input-group'),
        document.querySelector('.footer-address-input-group'),
        document.querySelector('.footer-website-input-group'),
    ];

    function checkFooterEnabled(enableFooterInput) {
        const footerPreviewText = document.querySelector('#footer-preview-text');
        const footerPreview = document.querySelector('.footer-preview');

        if (!enableFooterInput.checked) {
            footerPreviewText.textContent = "Preview (Footer Disabled)";
            footerPreview.classList.add('disabled');

            footerInputGroups.forEach(elem => {
                elem.classList.add('disabled');

                const inputs = elem.querySelectorAll('input');

                inputs.forEach(input => {
                    input.setAttribute('disabled', '');
                    input.setAttribute('aria-disabled', 'true');
                    input.setAttribute('tabindex', '-1');
                })

            });

        } else {
            footerPreviewText.textContent = "Preview";
            footerPreview.classList.remove('disabled');

            footerInputGroups.forEach(elem => {
                elem.classList.remove('disabled');

                const inputs = elem.querySelectorAll('input');

                inputs.forEach(input => {
                    input.removeAttribute('disabled');
                    input.removeAttribute('aria-disabled');
                    input.removeAttribute('tabindex');
                })
            });
        }
    }

    checkFooterEnabled(enableFooter);

    enableFooter.addEventListener('change', (ev) => {
        checkFooterEnabled(enableFooter);
    });

    const footerImgInputs = [
        [ document.querySelector('.branding-footer--footer-img'), 'footer-img-preview', 'branding-footer--footer-img-remove' ]
    ];

    footerImgInputs.forEach(arr => {
        const elem = arr[0];
        const previewImgId = arr[1];
        const removeBtnClass = arr[2];

        const removeBtn = document.querySelector(`.${removeBtnClass}`);
        const previewImg = document.querySelector(`#${previewImgId}`);

        elem.addEventListener('change', (ev) => {
            const [file] = ev.target.files;
            if (file) {
                previewImg.src = URL.createObjectURL(file);
            }
        });

        removeBtn.addEventListener('click', (ev) => {
            ev.preventDefault();
            elem.value = null;
            previewImg.src = webBooksLogo;
        });
    });

    const footerTextInputs = [
        [ document.querySelector('#footer_phone_no'), 'footer-phone-no-preview' ],
        [ document.querySelector('#footer_address'), 'footer-address-preview' ],
        [ document.querySelector('#footer_website'), 'footer-website-preview' ],
    ];

    footerTextInputs.forEach(arr => {
        const elem = arr[0];
        const previewTextId = arr[1];

        const previewText = document.querySelector(`#${previewTextId}`);

        elem.addEventListener('input', (ev) => {
            if (ev.target.value == '' || !ev.target.value || ev.target.value == null) {
                previewText.textContent = ev.target.dataset.default;
            } else {
                previewText.textContent = ev.target.value;
            }
        })
    })

})